import api from "../../../../../utils/api";

export const fetchProjects = async (
  setProjects,
  setProjectReports,
  setError,
  setLoading,
  toast
) => {
  try {
    setLoading(true);
    setError(null);
    const response = await api.get("/api/projects");
    setProjects(response.data);

    for (const project of response.data) {
      fetchProjectReports(project.id, setProjectReports);
    }
    setLoading(false);
  } catch (error) {
    console.error("Error fetching projects:", error);
    setError("Failed to load projects. Please try again later.");
    setLoading(false);
    toast.error("Failed to load projects");
  }
};

export const fetchProjectReports = async (projectId, setProjectReports) => {
  try {
    const response = await api.get(`/api/reports/project/${projectId}`);
    setProjectReports((prev) => ({
      ...prev,
      [projectId]: response.data,
    }));
  } catch (error) {
    console.error(`Error fetching reports for project ${projectId}:`, error);
  }
};
